var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-attachments-card.css';
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import ApprovalAttachmentsCardAPI from './approval-attachments-card-api';
let ApprovalAttachmentCard = class ApprovalAttachmentCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, fileDescription } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        fileDescription,
                    },
                }));
            }
        };
    }
    extractFileName(filename) {
        const questionMarkIndex = filename.indexOf('?');
        if (questionMarkIndex !== -1) {
            filename = filename.substring(0, questionMarkIndex);
        }
        const lastDashIndex = filename.lastIndexOf('-');
        return filename.substring(lastDashIndex + 1);
    }
    render() {
        const { fileDescription, } = this.props;
        const fancyDescription = this.extractFileName(fileDescription);
        return (React.createElement(Card, { transparent: false, className: "approval-item-card attachment-pointer", uuid: generateUUID(), onClick: () => this.onClick(), selectionType: SelectionType.NONE },
            React.createElement("div", { className: "approval-item-card__info" },
                React.createElement("div", { className: "attachment-icon-container" }, fancyDescription))));
    }
};
ApprovalAttachmentCard.propTypes = {
    fileDescription: string,
    onClick: eventListener,
};
ApprovalAttachmentCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalAttachmentsCardAPI })
], ApprovalAttachmentCard);
export default ApprovalAttachmentCard;
//# sourceMappingURL=approval-attachments-card.js.map